<!--==================================================
    component name  : 空箱查詢 - 彈出視窗
    author          : Samma
    last update     : 2020-05-07
    use description : 
==================================================-->
<template>
  <section id="lod">
    <div class="lopenbox" :class="{ show: open_win }">
      <!--視窗黑底-->
      <div class="blackbox" @click="$emit('close-window')"></div>
      <div class="allbox">
        <!--title-->
        <div class="orangebox">
          <div class="title">
            {{ win_data.lockers['site_i18n'][$i18n.locale] }}
          </div>
          <div class="lineall" @click="$emit('close-window')">
            <div class="line1"></div>
            <div class="line2"></div>
          </div>
        </div>

        <!--視窗內容-->
        <div class="whitebox">
          <div class="container">
            <div id="lobtn">
              <!--視窗分頁 title-->
              <ul class="tab-title">
                <li
                  id="tab-empty"
                  class="tab-item"
                  @click.prevent="
                    vTabGtag('空箱數', win_data.lockers['site_i18n']['zh-TW'])
                  "
                >
                  <div class="tablist active">
                    <a href="#tab01"></a>
                    <i class="fas fa-search"></i>
                    <div class="title">
                      {{ $t('message.qs_check_vacancy') }}
                    </div>
                  </div>
                </li>
                <li
                  id="tab-map"
                  class="tab-item"
                  @click.prevent="
                    vTabGtag('地圖', win_data.lockers['site_i18n']['zh-TW'])
                  "
                >
                  <div class="tablist">
                    <a href="#tab02"></a>
                    <i class="fas fa-map-marked-alt"></i>
                    <div class="title">{{ $t('message.qs_map') }}</div>
                  </div>
                </li>
                <li
                  id="tab-price"
                  class="tab-item"
                  @click.prevent="
                    vTabGtag('收費方式', win_data.lockers['site_i18n']['zh-TW'])
                  "
                >
                  <div class="tablist">
                    <a href="#tab03"></a>
                    <i class="fas fa-coins"></i>
                    <div class="title">{{ $t('message.qs_payment_way') }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="blackline"></div>

          <!--頁面 : 空箱數查詢-->
          <QsTab01 ref="qs_tab01"></QsTab01>

          <!--頁面 : 地圖-->
          <QsTab02 ref="qs_tab02"></QsTab02>

          <!--頁面 : 收費方式-->
          <QsTab03 ref="qs_tab03"></QsTab03>

          <!--離線顯示-->
          <div class="offlinebox" :class="{ show: is_win_no_data }">
            <div class="offallbox">
              <div class="imgbox">
                <img
                  class="img-fluid"
                  src="../assets/images/offline.svg"
                  alt="offline"
                />
              </div>
              <div class="text">
                {{
                  is_win_offline
                    ? $t('message.pb_offline')
                    : $t('message.qs_no_data')
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import QsTab01 from '@/components/QsTab01.vue';
import QsTab02 from '@/components/QsTab02.vue';
import QsTab03 from '@/components/QsTab03.vue';
import Public from '@/scripts/public';

export default {
  name: 'QsWin',
  props: {
    open_win: Boolean,
    click_site: Object,
  },
  components: {
    QsTab01,
    QsTab02,
    QsTab03,
  },
  data: function () {
    return {
      price_api: Public.appGetAPIURL('price'),
      //綁定 tab 切換事件註記
      tab_switch_event_bind: false,
      //彈出視窗內容
      win_data: {
        lockers: {
          //視窗 title
          site_i18n: {
            'zh-TW': '',
            'en-US': '',
          },
          site_no: '',
        },
      },
      //彈出視窗內無資料
      is_win_no_data: false,
      //強制顯示彈出視窗內的離線提示
      is_force_show_win_offline: false,
    };
  },
  computed: {
    //網路連線狀態 (彈出視窗)
    is_win_offline: function () {
      return this.is_force_show_win_offline || this.is_offline;
    },
    ...mapState(['is_offline']),
  },
  mounted: function () {},
  updated: function () {
    var ref = this;
    this.$nextTick(function () {
      //UI 事件綁定
      if (!ref.tab_switch_event_bind) {
        ref.tab_switch_event_bind = true;

        //切換 tab 時更換樣式
        var $li = $('ul.tab-title li');
        $($li.eq(0).addClass('active').find('a').attr('href'))
          .siblings('.tab-inner')
          .hide();

        $li.click(function () {
          $($(this).find('a').attr('href'))
            .show()
            .siblings('.tab-inner')
            .hide();
          $(this).addClass('active').siblings('.active').removeClass('active');
          //依照當前 tab 頁對網路連線進行相關的處理
          ref.vCheckSelectedTab();
        });
      }
    });
  },
  methods: {
    //設定彈出視窗內是否強制顯示離線提示
    vSetForceWinOffline: function (is_show) {
      this.is_force_show_win_offline = is_show;
    },
    //確認彈出視窗當前顯示的 tab 頁面
    vCheckSelectedTab: function () {
      var current_tab = '';
      $('.tab-item').each(function (i, elem) {
        var class_name = $(elem).attr('class');
        var id_name = $(elem).attr('id');
        //取得目前選取的 tab id
        if (class_name.indexOf('active') >= 0) {
          current_tab = id_name;
        }
      });
      if (current_tab == 'tab-empty') {
        this.vShowtab01();
      } else if (current_tab == 'tab-map') {
        this.vShowtab02();
      } else if (current_tab == 'tab-price') {
        this.vShowtab03();
      }
    },
    // //設定是否顯示 tab01 內容
    vShowtab01: function () {
      this.vSetForceWinOffline(false);
      this.is_win_no_data = this.$refs.qs_tab01.vCheckNoContent();
      this.$refs.qs_tab01.vShowContent(!this.is_win_no_data);
    },
    // //設定是否顯示地圖(依網路連線狀態)
    vShowtab02: function () {
      this.vSetForceWinOffline(this.is_offline);
      //確認是否有地圖資料
      this.is_win_no_data = this.$refs.qs_tab02.vCheckNoContent();
      //若當前離線，強制隱藏地圖
      if (this.is_offline) {
        this.is_win_no_data = true;
        this.$refs.qs_tab02.vShowContent(false);
      } else {
        this.$refs.qs_tab02.vShowContent(!this.is_win_no_data);
      }
    },
    // //設定是否顯示 tab03 內容
    vShowtab03: function () {
      this.vSetForceWinOffline(false);
      this.is_win_no_data = this.$refs.qs_tab03.vCheckNoContent();
      this.$refs.qs_tab03.vShowContent(!this.is_win_no_data);
    },
    //初始化視窗資料
    vInitWindowStatus: function () {
      //重置 tab01 的內容
      this.$refs.qs_tab01.vInitUIStatus();
      //重置 tab02 的內容
      this.$refs.qs_tab02.vInitUIStatus();
      //重置 tab03 的內容
      this.$refs.qs_tab03.vInitUIStatus();
    },
    //取得指定站點的詳細資訊
    vLoadDetailSite: function (site) {
      var ref = this;
      // 目前測試區資料也是來自正式環境，將不再進行區分
      const url = `${this.price_api}/${site['site_no']}`;

      if (!url || url.length <= 0) {
        return;
      }

      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(url).then((data) => {
        ref.vRenderSiteDetails(site, data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(url).then((data) => {
        ref.vRenderSiteDetails(site, data);
      });
    },
    vRenderSiteDetails: function (site, fee_data) {
      var i = 0,
        j = 0,
        s = 0;

      //重設站點明細資料
      this.vInitWindowStatus();
      this.win_data = {
        lockers: {
          //視窗 title
          site_i18n: site['site_i18n'],
          site_no: site['site_no'],
        },
      };

      if (fee_data && fee_data['price'] && fee_data['price'].length > 0) {
        /*依前端需求重整副櫃尺寸代碼
              後台 => S:充電櫃 / M:小櫃 / L:大櫃
              前台 => M:充電櫃 / S:小櫃 / L:大櫃
            */
        for (i = 0; i < fee_data['price'].length; i++) {
          for (j = 0; j < fee_data['price'][i]['fee'].length; j++) {
            if (fee_data['price'][i]['fee'][j]['size'] == 'M') {
              fee_data['price'][i]['fee'][j]['size'] = 'S';
            } else if (fee_data['price'][i]['fee'][j]['size'] == 'S') {
              fee_data['price'][i]['fee'][j]['size'] = 'M';
            }
          }
        }

        //依 UI 需求，依副櫃尺寸排序資料
        for (i = 0; i < fee_data['price'].length; i++) {
          fee_data['price'][i]['fee'] = fee_data['price'][i]['fee'].sort(
            function (a, b) {
              var a_sorted = Public.pbLockerTypeSort(a.size);
              var b_sorted = Public.pbLockerTypeSort(b.size);
              return a_sorted > b_sorted ? 1 : -1;
            }
          );
        }

        //將 site["lockers_type"] 內的資料補充完整
        var lockers_type = site['lockers_type'];
        for (i = 0; i < lockers_type.length; i++) {
          for (j = 0; j < fee_data['price'].length; j++) {
            if (fee_data['price'][j]['min_hour'] <= 1) {
              for (s = 0; s < fee_data['price'][j]['fee'].length; s++) {
                if (
                  lockers_type[i]['size'] ==
                  fee_data['price'][j]['fee'][s]['size']
                ) {
                  lockers_type[i]['unit_fee'] =
                    fee_data['price'][j]['fee'][s]['unit_fee'];
                  lockers_type[i]['unit_hour'] =
                    fee_data['price'][j]['fee'][s]['unit_hour'];
                  lockers_type[i]['spec'] =
                    fee_data['price'][j]['fee'][s]['spec'];
                }
              }
            }
          }
        }
        //更新彈出視窗 - tab01 的資料
        this.$refs.qs_tab01.vLoadLockersType(lockers_type);
        this.$refs.qs_tab01.vLoadUpdatedAt(site['updated_at']);

        // //更新彈出視窗 - tab02 的資料
        var map_src =
          fee_data && fee_data['iframe_map'] ? fee_data['iframe_map'] : '';
        this.$refs.qs_tab02.vLoadMap(map_src);

        //更新彈出視窗 - tab03 的資料
        var fee_desc_hours =
          site['lockers_type'].length > 0
            ? site['lockers_type'][0]['unit_hour']
            : null;
        this.$refs.qs_tab03.vLoadFeeDescHours(fee_desc_hours);
        var price = fee_data && fee_data['price'] ? fee_data['price'] : [];
        this.$refs.qs_tab03.vLoadPrices(price);
        this.$refs.qs_tab03.vLoadSiteNo(site['site_no']);
        var over_day =
          fee_data && fee_data['over_day'] ? fee_data['over_day'] : null;
        this.$refs.qs_tab03.vLoadOverDay(over_day);
        var lonest_day =
          fee_data && fee_data['lonest_day'] ? fee_data['lonest_day'] : null;
        this.$refs.qs_tab03.vLoadLonestDay(lonest_day);
        var payment_way =
          fee_data && fee_data['payment'] ? fee_data['payment'] : null;
        this.$refs.qs_tab03.vLoadPaymentWay(payment_way);
        this.$refs.qs_tab03.vLoadLockersType(lockers_type);
      }

      //確認當前所選擇的 tab 進行相關的設定
      this.vCheckSelectedTab();
      //打開視窗
      this.$emit('open-window');
      //視窗開啟時自動滑到最上面
      $('html , body').animate({ scrollTop: 0 }, 500);
    },
    vTabGtag: function (action, label) {
      //Gtag Event
      this.$gtag.event(action, {
        event_category: '空櫃/價格查詢',
        event_label: label,
        value: 1,
      });
    },
  },
  watch: {
    is_offline: function (new_val) {
      //online
      if (!new_val) {
        //若視窗開著，取得指定站點的詳細資訊
        if (this.open_win && this.click_site) {
          this.vLoadDetailSite(this.click_site);
        }
        //若視窗開著，依照當前 tab 頁對網路連線進行相關的處理
        if (this.open_win) {
          this.vCheckSelectedTab();
        }

        //offline
      } else {
        //若視窗開著，依照當前 tab 頁對網路連線進行相關的處理
        if (this.open_win) {
          this.vCheckSelectedTab();
        }
      }
    },
  },
};
</script>
